import { useEffect, useRef } from "react";
import useApiRequisiciones from "../../api/taller/useApiRequisicion";
import useApiSource from "../../api/source";

export default function ComercialNuevo() {
    const apiSource = useApiSource();
    const apiRequisiciones = useApiRequisiciones();
    const apiRef = useRef(null);
    apiRef.current = {
        requisiciones: apiRequisiciones,
        source: apiSource,
    };

    useEffect(() => {
        if (
            typeof window.mountRequisiciones !==
            "function"
        ) {
            console.error(
                "No se encontró window.mountRequisiciones. " +
                "Verifica que esté cargado ui-widget.iife.js."
            );

            return undefined;
        }

        console.log(
            "API entregada al microfrontend:",
            apiRef.current
        );

        console.log(
            "API Source:",
            apiRef.current?.source
        );

        const desmontar = window.mountRequisiciones(
            "requisiciones-nuevo",
            {
                api: apiRef.current,
            }
        );

        return () => {
            if (typeof desmontar === "function") {
                desmontar();
            }
        };
    }, []);

    return <div id="requisiciones-nuevo" />;
}